import { ReactNode } from 'react';

import { DownOutlined, RightOutlined } from '@ant-design/icons';
import { cx } from '@emotion/css';
import { Table } from 'antd';
import { ColumnsType, TablePaginationConfig } from 'antd/lib/table';
import { ExpandableConfig, GetRowKey } from 'antd/lib/table/interface';
import { isUndefined } from 'lodash';

import * as Styles from './MTable.styles';

export const HISTORY_PATH = 'history';

interface MTableProps<D extends object> {
  columns: ColumnsType<any> | undefined;
  data: D[];
  loading?: boolean;
  onRowClick?: (record: D, index?: number) => void;
  onChange?: (pagination: TablePaginationConfig) => void;
  rowKey?: string | GetRowKey<D>;
  showHeader?: boolean;
  expandable?: Omit<ExpandableConfig<D>, 'expandIcon'>;
  indentSize?: number;
  emptyState?: ReactNode | (() => ReactNode);
  pagination?: false | TablePaginationConfig | undefined;
  tableStyle?: string | undefined;
  scroll?:
    | ({
        x?: string | number | true | undefined;
        y?: string | number | undefined;
      } & {
        scrollToFirstRowOnChange?: boolean | undefined;
      })
    | undefined;
  testId?: string;
}

export function MTable<D extends object>({
  columns,
  data,
  loading = false,
  pagination = false,
  onRowClick,
  onChange,
  rowKey,
  expandable,
  indentSize,
  scroll = undefined,
  tableStyle = '',
  emptyState = undefined,
  testId,
  showHeader = true,
}: MTableProps<D>) {
  return (
    <Table
      columns={columns}
      dataSource={data}
      pagination={pagination}
      loading={loading}
      scroll={scroll}
      rowKey={rowKey}
      showHeader={showHeader}
      indentSize={indentSize}
      onRow={
        onRowClick
          ? (record, rowIndex?: number) => {
              return {
                onClick: () => onRowClick(record, rowIndex),
              };
            }
          : undefined
      }
      onChange={onChange}
      expandable={
        isUndefined(expandable)
          ? undefined
          : {
              ...expandable,
              expandIcon: ({ expanded, onExpand, record }) => {
                return expanded ? (
                  <DownOutlined onClick={e => onExpand(record, e)} />
                ) : (
                  <RightOutlined onClick={e => onExpand(record, e)} />
                );
              },
            }
      }
      locale={{ emptyText: emptyState }}
      className={cx(Styles.tableHeader, tableStyle)}
      data-testid={testId}
    />
  );
}
